import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebaseConfig';
import { collection, query, orderBy, getDocs, addDoc, serverTimestamp, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import emailToName from '../utils/emailToName';
import { socket } from '../socket';

// 공지사항 등록 모달
const NoticeRegisterModal = ({ open, onClose, onRegister }: { open: boolean, onClose: () => void, onRegister: (title: string, content: string) => void }) => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!title.trim() || !content.trim()) return;
    setLoading(true);
    await onRegister(title, content);
    setLoading(false);
    setTitle('');
    setContent('');
    onClose();
  };

  if (!open) return null;

  return (
    <div style={{ position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.18)', zIndex: 10000 }}>
      <div style={{ background: '#fff', borderRadius: 12, minWidth: 500, maxWidth: 700, minHeight: 400, boxShadow: '0 2px 16px rgba(0,0,0,0.18)', padding: 32, position: 'absolute', left: '50%', top: '20%', transform: 'translate(-50%, 0)' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 18, right: 18, fontSize: 20, background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
        <div style={{ fontWeight: 700, fontSize: 20, marginBottom: 18, color: '#666666' }}>공지사항 등록</div>
        <div style={{ marginBottom: 12 }}>
          <input 
            type="text" 
            value={title} 
            onChange={e => setTitle(e.target.value)} 
            placeholder="제목" 
            style={{ width: '100%', fontSize: 16, padding: 8, borderRadius: 4, border: '1px solid #bbb', marginBottom: 8 }} 
          />
          <textarea 
            value={content} 
            onChange={e => setContent(e.target.value)} 
            placeholder="내용" 
            style={{ width: '100%', fontSize: 15, padding: 8, borderRadius: 4, border: '1px solid #bbb', minHeight: 180 }} 
          />
        </div>
        <button 
          style={{ background: '#1976d2', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 22px', fontWeight: 600, fontSize: 16, marginTop: 8, cursor: 'pointer' }} 
          onClick={handleSubmit} 
          disabled={loading}
        >
          {loading ? '등록중...' : '등록'}
        </button>
      </div>
    </div>
  );
};

// 공지사항 수정 모달
const NoticeEditModal = ({ open, onClose, notice, onSave }: { open: boolean, onClose: () => void, notice: any, onSave: (title: string, content: string) => void }) => {
  const [title, setTitle] = useState(notice?.title || '');
  const [content, setContent] = useState(notice?.content || '');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTitle(notice?.title || '');
    setContent(notice?.content || '');
  }, [notice]);

  const handleSubmit = async () => {
    if (!title.trim() || !content.trim()) return;
    setLoading(true);
    await onSave(title, content);
    setLoading(false);
    onClose();
  };

  if (!open) return null;

  return (
    <div style={{ position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.18)', zIndex: 10001 }}>
      <div style={{ background: '#fff', borderRadius: 12, minWidth: 700, maxWidth: 900, minHeight: 500, boxShadow: '0 2px 16px rgba(0,0,0,0.18)', padding: 32, position: 'absolute', left: '50%', top: '20%', transform: 'translate(-50%, 0)' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 18, right: 18, fontSize: 20, background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
        <div style={{ fontWeight: 700, fontSize: 20, marginBottom: 18, color: '#666666' }}>공지사항 수정</div>
        <div style={{ marginBottom: 12 }}>
          <input 
            type="text" 
            value={title} 
            onChange={e => setTitle(e.target.value)} 
            placeholder="제목" 
            style={{ width: '100%', fontSize: 16, padding: 8, borderRadius: 4, border: '1px solid #bbb', marginBottom: 8 }} 
          />
          <textarea 
            value={content} 
            onChange={e => setContent(e.target.value)} 
            placeholder="내용" 
            style={{ width: '100%', fontSize: 15, padding: 8, borderRadius: 4, border: '1px solid #bbb', minHeight: 260 }} 
          />
        </div>
        <button 
          style={{ background: '#1976d2', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 22px', fontWeight: 600, fontSize: 16, marginTop: 8, cursor: 'pointer' }} 
          onClick={handleSubmit} 
          disabled={loading}
        >
          {loading ? '저장중...' : '저장'}
        </button>
      </div>
    </div>
  );
};

// 공지사항 상세 모달
const NoticeDetailModal = ({ open, onClose, notice, onEdit, onDelete, isMine }: { open: boolean, onClose: () => void, notice: any, onEdit: () => void, onDelete: () => void, isMine: boolean }) => {
  if (!open || !notice) return null;
  return (
    <div style={{ position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.18)', zIndex: 10002 }}>
      <div style={{ background: '#fff', borderRadius: 12, minWidth: 500, maxWidth: 700, minHeight: 300, maxHeight: '80vh', boxShadow: '0 2px 16px rgba(0,0,0,0.18)', padding: 32, position: 'absolute', left: '50%', top: '20%', transform: 'translate(-50%, 0)', display: 'flex', flexDirection: 'column' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 18, right: 18, fontSize: 20, background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
        <div style={{ fontWeight: 700, fontSize: 22, color: '#666666', marginBottom: 12 }}>{notice.title}</div>
        <div style={{ color: '#444', fontSize: 16, lineHeight: 1.7, whiteSpace: 'pre-line', wordBreak: 'break-all', marginBottom: 18, overflowY: 'auto', maxHeight: '45vh' }}>{notice.content}</div>
        <div style={{ color: '#bbb', fontSize: 14, marginBottom: 18 }}>
          등록: {notice.createdAt?.toDate ? notice.createdAt.toDate().toLocaleString() : ''} / 작성자: {emailToName[notice.authorEmail] || notice.authorEmail}
        </div>
        {isMine && (
          <div style={{ display: 'flex', gap: 8 }}>
            <button 
              onClick={onEdit}
              style={{ background: '#fff', color: '#1976d2', border: '1px solid #1976d2', borderRadius: 6, padding: '6px 12px', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}
            >수정</button>
            <button 
              onClick={onDelete}
              style={{ background: '#fff', color: '#d32f2f', border: '1px solid #d32f2f', borderRadius: 6, padding: '6px 12px', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}
            >삭제</button>
          </div>
        )}
      </div>
    </div>
  );
};

const NoticeBoardPage = () => {
  const [notices, setNotices] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showRegister, setShowRegister] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [editNotice, setEditNotice] = useState<any>(null);
  const [showDetail, setShowDetail] = useState(false);
  const [detailNotice, setDetailNotice] = useState<any>(null);
  const [page, setPage] = useState(1);
  const [hoveredId, setHoveredId] = useState<string | null>(null);
  const PAGE_SIZE = 10;
  const user = auth.currentUser;

  // 공지사항 목록 불러오기
  const fetchNotices = async () => {
    setLoading(true);
    const q = query(collection(db, 'notices'), orderBy('createdAt', 'desc'));
    const snap = await getDocs(q);
    setNotices(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    setLoading(false);
  };

  useEffect(() => {
    fetchNotices();
  }, []);

  // 페이지네이션 계산
  const totalPages = Math.ceil(notices.length / PAGE_SIZE);
  const pagedNotices = notices.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  // 공지사항 등록
  const handleRegister = async (title: string, content: string) => {
    const docRef = await addDoc(collection(db, 'notices'), {
      type: '공지',
      title,
      content,
      createdAt: serverTimestamp(),
      authorId: user?.uid || '',
      authorEmail: user?.email || '',
    });
    
    // 소켓 이벤트 발생
    console.log('[NoticeBoardPage] emit: notice-added', { id: docRef.id, title, content, authorEmail: user?.email || '' });
    socket.emit('notice-added', {
      id: docRef.id,
      title,
      content,
      authorEmail: user?.email || ''
    });
    
    fetchNotices();
  };

  // 공지사항 수정
  const handleEdit = (notice: any) => {
    setEditNotice(notice);
    setShowEdit(true);
    setShowDetail(false);
  };

  const handleEditSave = async (title: string, content: string) => {
    if (!editNotice) return;
    await updateDoc(doc(db, 'notices', editNotice.id), {
      title,
      content,
    });
    
    // 소켓 이벤트 발생
    console.log('[NoticeBoardPage] emit: notice-updated', { id: editNotice.id, title, content, authorEmail: user?.email || '' });
    socket.emit('notice-updated', {
      id: editNotice.id,
      title,
      content,
      authorEmail: user?.email || ''
    });
    
    setShowEdit(false);
    setEditNotice(null);
    fetchNotices();
  };

  // 공지사항 삭제
  const handleDelete = async (id: string) => {
    if (!window.confirm('정말 삭제하시겠습니까?')) return;
    await deleteDoc(doc(db, 'notices', id));
    
    // 소켓 이벤트 발생
    console.log('[NoticeBoardPage] emit: notice-deleted', { id, authorEmail: user?.email || '' });
    socket.emit('notice-deleted', {
      id,
      authorEmail: user?.email || ''
    });
    
    setShowDetail(false);
    fetchNotices();
  };

  // 공지사항 상세 보기
  const handleShowDetail = (notice: any) => {
    setDetailNotice(notice);
    setShowDetail(true);
  };

  return (
    <div style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box', padding: '36px clamp(20px, 4vw, 56px)' }}>
      {/* 헤더 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 40 }}>
        <div style={{ fontWeight: 700, fontSize: 20, color: '#444444' }}>공지사항 게시판</div>
        <button 
          onClick={() => setShowRegister(true)}
          style={{ 
            background: '#1976d2', 
            color: '#fff', 
            border: 'none', 
            borderRadius: 8, 
            padding: '12px 24px', 
            fontWeight: 600, 
            fontSize: 16, 
            cursor: 'pointer' 
          }}
        >
          공지사항 등록
        </button>
      </div>

      {/* 공지사항 목록 */}
      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 16px rgba(0,0,0,0.10)', padding: 32 }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#666' }}>로딩 중...</div>
        ) : notices.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#888' }}>등록된 공지사항이 없습니다.</div>
        ) : (
          <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
              {pagedNotices.map(notice => {
                const isMine = user && notice.authorId === user.uid;
                const isHovered = hoveredId === notice.id;
                return (
                  <div
                    key={notice.id}
                    style={{
                      borderBottom: '1px solid #eee',
                      padding: '18px 0',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      background: isHovered ? '#f5f7fa' : 'transparent'
                    }}
                    onMouseEnter={() => setHoveredId(notice.id)}
                    onMouseLeave={() => setHoveredId(null)}
                  >
                                         <div
                       onClick={() => handleShowDetail(notice)}
                       style={{
                         flex: 1,
                         fontWeight: 700,
                         fontSize: 18,
                         color: isHovered ? '#444444' : '#666666',
                         textDecoration: isHovered ? 'underline' : 'none',
                         display: 'flex',
                         alignItems: 'center',
                         gap: 8
                       }}
                     >
                       {notice.title}
                                               {(() => {
                          const now = new Date();
                          const today = new Date(now);
                          today.setHours(0, 0, 0, 0); // 오늘 시작 시간
                          
                          const tomorrow = new Date(now);
                          tomorrow.setDate(tomorrow.getDate() + 1);
                          tomorrow.setHours(23, 59, 59, 999); // 내일 마지막 시간
                          
                          const noticeDate = notice.createdAt?.toDate ? notice.createdAt.toDate() : new Date();
                          
                          // 오늘과 내일 작성된 글만 N 표시
                          if (noticeDate >= today && noticeDate <= tomorrow) {
                           return (
                             <span style={{
                               background: '#ff4444',
                               color: '#fff',
                               fontSize: 12,
                               fontWeight: 700,
                               padding: '3px 7px',
                               borderRadius: 12,
                               minWidth: 18,
                               textAlign: 'center',
                               lineHeight: 1
                             }}>
                               N
                             </span>
                           );
                         }
                         return null;
                       })()}
                     </div>
                    <div style={{ color: '#bbb', fontSize: 14, marginLeft: 24, minWidth: 180, textAlign: 'right' }}>
                      {notice.createdAt?.toDate ? notice.createdAt.toDate().toLocaleString() : ''} / {emailToName[notice.authorEmail] || notice.authorEmail}
                    </div>
                  </div>
                );
              })}
            </div>
            {/* 페이지네이션 */}
            {totalPages > 1 && (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 32, gap: 8 }}>
                {/* 이전 페이지 버튼 */}
                {page > 1 && (
                  <button
                    onClick={() => setPage(page - 1)}
                    style={{
                      minWidth: 36,
                      height: 36,
                      borderRadius: 6,
                      border: '1px solid #ccc',
                      background: '#fff',
                      color: '#666',
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: 'pointer',
                      outline: 'none',
                      transition: 'all 0.15s',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    ‹
                  </button>
                )}
                
                {/* 페이지 번호들 */}
                {(() => {
                  const maxVisiblePages = 5;
                  let startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2));
                  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
                  
                  // 끝 페이지가 totalPages에 가까우면 시작 페이지를 조정
                  if (endPage - startPage + 1 < maxVisiblePages) {
                    startPage = Math.max(1, endPage - maxVisiblePages + 1);
                  }
                  
                  const pages: number[] = [];
                  for (let i = startPage; i <= endPage; i++) {
                    pages.push(i);
                  }
                  
                  return pages.map(num => (
                    <button
                      key={num}
                      onClick={() => setPage(num)}
                      style={{
                        minWidth: 36,
                        height: 36,
                        borderRadius: 6,
                        border: num === page ? '2px solid #1976d2' : '1px solid #ccc',
                        background: num === page ? '#1976d2' : '#fff',
                        color: num === page ? '#fff' : '#222',
                        fontWeight: 600,
                        fontSize: 15,
                        cursor: 'pointer',
                        outline: 'none',
                        transition: 'all 0.15s',
                      }}
                    >
                      {num}
                    </button>
                  ));
                })()}
                
                {/* 다음 페이지 버튼 */}
                {page < totalPages && (
                  <button
                    onClick={() => setPage(page + 1)}
                    style={{
                      minWidth: 36,
                      height: 36,
                      borderRadius: 6,
                      border: '1px solid #ccc',
                      background: '#fff',
                      color: '#666',
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: 'pointer',
                      outline: 'none',
                      transition: 'all 0.15s',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    ›
                  </button>
                )}
              </div>
            )}
          </>
        )}
      </div>

      {/* 모달들 */}
      <NoticeRegisterModal 
        open={showRegister} 
        onClose={() => setShowRegister(false)} 
        onRegister={handleRegister} 
      />
      <NoticeEditModal 
        open={showEdit} 
        onClose={() => { setShowEdit(false); setEditNotice(null); }} 
        notice={editNotice} 
        onSave={handleEditSave} 
      />
      <NoticeDetailModal 
        open={showDetail} 
        onClose={() => setShowDetail(false)} 
        notice={detailNotice} 
        onEdit={() => handleEdit(detailNotice)} 
        onDelete={() => handleDelete(detailNotice?.id)} 
        isMine={user && detailNotice && detailNotice.authorId === user.uid} 
      />
    </div>
  );
};

export default NoticeBoardPage; 